/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

let Custom = (function () {
    function isCartPage() {
        return window.location.pathname === '/cart' ||
            window.location.pathname.startsWith('/cart/');
    }

    function isProductPage()
    {
        return window.location.pathname.includes('/products/') &&
            document.querySelector('.product-form, [data-product-id]') !== null;
    }

    function formatMoney(price, currency) {
        // Mapowanie walut na locale
        const locales = {
            'PLN': 'pl-PL',
            'USD': 'en-US',
            'EUR': 'de-DE',
            'GBP': 'en-GB'
        };

        if(currency === undefined)
            currency = Shopify.currency.active;

        const locale = locales[currency] || 'en-US';

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(price);
    }

    function initToolTips()
    {
        const tooltips = document.querySelectorAll('.info-tooltip-wrapper');

        tooltips.forEach(wrapper => {
            const btn = wrapper.querySelector('.info-tooltip-btn');
            const content = wrapper.querySelector('.tooltip-content');
            const closeBtn = wrapper.querySelector('.tooltip-close');

            btn.addEventListener('click', function(e) {
                e.stopPropagation();

                // Zamknij inne tooltipy
                document.querySelectorAll('.tooltip-content').forEach(tc => {
                    if (tc !== content) tc.style.display = 'none';
                });

                // Przełącz aktualny
                const isVisible = content.style.display === 'block';
                content.style.display = isVisible ? 'none' : 'block';
            });

            closeBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                content.style.display = 'none';
            });

            // Kliknięcie poza tooltip — zamyka wszystkie
            document.addEventListener('click', function() {
                content.style.display = 'none';
            });

            content.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        });
    }

    function dispatchEvent(__element, __event)
    {
        let event = new Event(__event, { bubbles: true });
        __element.dispatchEvent(event);
    }

    function updateProductVariantId(__product_variant_id)
    {
        const variantInput = document.getElementsByName('id')[0];
        variantInput.value = __product_variant_id;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantInput.value);
        window.history.replaceState({}, '', url);
    }


    function getShowContactFormButtons()
    {
        return document.querySelectorAll('.contact-form-toggle');
    }

    function initContactForm(__show_text, __hide_text)
    {
        const formful_section = findSectionWithFormfulBlock();
        if(formful_section)
        {
            formful_section.style.display = 'none';

            getShowContactFormButtons().forEach(function(__btn){
                __btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    toggleElementVisibility({
                        btn: __btn,
                        elementId: formful_section.id
                    });
                });
            });

            document.querySelectorAll('.formful__button').forEach(function(__button){
                __button.classList.add("btn", "btn--neutral");
            });
        }


    }


    function findSectionWithFormfulBlock() {
        // Znajdź div z ID zawierającym "formful_app_block_form"
        const formfulDiv = document.querySelector('[id*="formful_app_block_form"]');

        if (!formfulDiv) {
            return null;
        }

        // Znajdź najbliższą sekcję Shopify
        const section = formfulDiv.closest('[id^="shopify-section-"]');

        return section;
    }

    function toggleElementVisibility(options) {
        const element = document.getElementById(options.elementId);
        const isHidden = element.style.display === 'none' ||
            window.getComputedStyle(element).display === 'none';

        let init_btn = options.btn;

        if (isHidden) {
            element.style.display = 'block';
            element.offsetHeight; // wymusza reflow

            getShowContactFormButtons().forEach(function(__btn){
                if(__btn.dataset.hideText)
                    __btn.textContent = __btn.dataset.hideText;
            });
        }
        else {
            if(init_btn.dataset.hideText)
            {
                element.style.display = 'none';
                getShowContactFormButtons().forEach(function(__btn){
                    __btn.textContent = __btn.dataset.showText;
                });
            }

        }

        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function isMobile()
    {
        let photo_editor_mobile_test = document.querySelector(".is_mobile_test");
        if(photo_editor_mobile_test)
        {
            return isElementVisible(photo_editor_mobile_test)
        }

        return false;
    }

    function isElementVisible(__element)
    {
        var style = window.getComputedStyle(__element);
        return !(style.display === 'none');
    }

    function showElement(__element)
    {
        __element.style.display = 'inherit';
    }

    function hideElement(__element)
    {
        __element.style.display = 'none';
    }

    function hasInvalidElements(__div)
    {
        let invalid_divs = __div.querySelector('.error, .invalid, input:invalid');
        if(invalid_divs)
            return true;
        return false;
    }

    function initDropdowns()
    {

        document.querySelectorAll(".dropdown").forEach(function(dropdown){
            dropdown
                .querySelector('.dropdown-button')
                .onclick = function() {
                dropdown.classList.toggle('open');
            };

            // Zamknij dropdown po kliknięciu poza nim
            document.addEventListener('click', function(event) {
                if (!dropdown.contains(event.target)) {
                    dropdown.classList.remove('open');
                }
            });
        })

    }

    function initSliders()
    {
        for (let slider_action of document.getElementsByClassName('slider-actions')) {
            slider_action.classList.remove('hide');
        }
    }

    /**
     *
     * @param {number} value
     * @param {string} fromUnit
     * @param {string} toUnit
     * @returns {number}
     */
    function convertToUnit(value, fromUnit, toUnit) {


        // Konwersja do cm jako jednostki bazowej
        const toCm = {
            'cm': 1,
            'mm': 0.1,
            'm': 100,
            'in': 2.54
        };

        // Konwertuj do cm, potem do docelowej jednostki
        const valueInCm = value * toCm[fromUnit];
        const result = valueInCm / toCm[toUnit];

        return result;
    }

    async function downloadAsPng(url, filename = "preview.png") {
        const res = await fetch(url, {
            headers: { Accept: "image/png,image/*;q=0.8,*/*;q=0.5" }
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();

        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(a.href);
    }

    function setLastCollection(url) {
        try {
            if (url && url.includes('/collections/')) {
                sessionStorage.setItem('last_collection_url', url);
            }
        } catch (e) {}
    }

    function saveLastCollection() {

        // Jeśli jesteśmy na stronie kolekcji
        if (location.pathname.startsWith('/collections/') && !location.pathname.includes('/products/')) {
            setLastCollection(location.pathname + location.search);
            return;
        }

        // Jeśli jesteśmy na produkcie: ustaw domyślną kolekcję produktu
        try {

            if (window.__defaultProductCollectionUrl) {
                setLastCollection(window.__defaultProductCollectionUrl);
            }
        } catch (e) {}
    }


    function init()
    {
        if(isProductPage())
        {
            ProductPage.init();
        }
        else
            initContactForm();

        saveLastCollection();

        if(isCartPage())
            CartPage.init();
    }



    return {
        isCartPage: isCartPage,
        isProductPage: isProductPage,
        formatMoney: formatMoney,
        initToolTips: initToolTips,
        dispatchEvent: dispatchEvent,
        updateProductVariantId: updateProductVariantId,
        initContactForm: initContactForm,
        isElementVisible: isElementVisible,
        hideElement: hideElement,
        showElement: showElement,
        hasInvalidElements: hasInvalidElements,
        initDropdowns: initDropdowns,
        isMobile: isMobile,
        convertToUnit: convertToUnit,
        downloadAsPng: downloadAsPng,
        initSliders: initSliders,
        init: init,
    }
})();


(function() {
    // scroll position do searcha
    function adjustPopdownPosition() {
        const searchPopdown = document.querySelector('.search-popdown');
        const scrollPosition = window.scrollY;
        if (scrollPosition === 0) {
            if (window.innerWidth <= 767) {
                searchPopdown.style.top = "110px";
            } else {
                searchPopdown.style.top = "153px";
            }
        }else
        if (window.innerWidth <= 767) {
            searchPopdown.style.top = "68px";
        } else {
            searchPopdown.style.top = "110px";
        }
    }

    // wielkosc elementu menu 2 kratki ostatnie się nie rozwija
    function partnerBoxWidth(){
        const contact_width= document.querySelector('.header__desktop .menu__item.child').offsetWidth;
        const partner_width= document.querySelector('.header__desktop .menu__item.parent').offsetWidth;
        const partner_box_width = contact_width + partner_width + 23;

        document.documentElement.style.setProperty('--partner-box-width', `${partner_box_width}px`);
    }


    // Wywołaj funkcję przy scrollowaniu
    function handleScroll() {
        adjustPopdownPosition();
        partnerBoxWidth();
    }
    window.addEventListener('scroll', handleScroll);

    // Wywołaj funkcję przy załadowaniu strony
    function handleLoad() {
        adjustPopdownPosition();
        partnerBoxWidth();
    }
    window.addEventListener('load', handleLoad);

    // Wywołaj funkcję przy przeskalowaniu strony
    function handleResize() {
        adjustPopdownPosition();
        partnerBoxWidth();
    }
    window.addEventListener('resize', handleResize);


    document.addEventListener('DOMContentLoaded', function() {
        Custom.init();
    });


})();

